/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/utils',
        'assets/js/modules/widgets/pricingCalculator/view/pricingCalcItemView',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/assets'
    ],
    function($, _, utils, PricingCalcItemView, OptionModel, OptionValueModel, assets) {
        var SAMPLE_PATH = assets.generate('assets/images/designPreview/designSamples/');
        var OPTION_VALUES_WITH_IMAGE = [OptionValueModel.NAME_NONE_TRIMMING];
        var OPTION_VALUES_PRICING_DISPLAY = [
            OptionValueModel.NAME_ROUNDED_CORNERS,
            OptionValueModel.NAME_TRIMMING,
            OptionValueModel.NAME_FRONT_COATING_FULL_UV,
            OptionValueModel.NAME_BACK_COATING_FULL_UV,
            OptionValueModel.NAME_FRONT_COATING_SPOT_UV,
            OptionValueModel.NAME_BACK_COATING_SPOT_UV,
            OptionValueModel.NAME_FRONT_COATING_SOFT_TOUCH_LAMINATE,
            OptionValueModel.NAME_FRONT_COATING_TEXTURE,
            OptionValueModel.NAME_BACK_COATING_TEXTURE,
            OptionValueModel.NAME_FRONT_COATING_FOIL,
            OptionValueModel.NAME_BACK_COATING_FOIL
        ];
        var OPTION_VALUES_ALTERNATIVE_PRICING_DISPLAY = [
            OptionValueModel.NAME_WHITE_ENV,
            OptionValueModel.NAME_RED_ENV,
            OptionValueModel.NAME_GREEN_ENV,
            OptionValueModel.NAME_BLUE_ENV
        ];
        var SHOW_AS_ENABLED_OPTIONS = [OptionModel.NAME_SUBSTRATE];

        return PricingCalcItemView.extend({
            pricingSetName: null,

            initialize: function(options) {
                this.pricingSetName = options.pricingSetName;

                PricingCalcItemView.prototype.initialize.apply(this, arguments);
            },

            /**
             * @param {PricingCalcSkuModel} pricingCalcSku
             * @param {PricingCalcItemModel} pricingCalcItem
             * @returns {function}
             */
            skuOptionTmpl: function(pricingCalcSku, pricingCalcItem) {
                var _this = this;

                var tmpl = _.template(
                    [
                        '<option value="<%- id %>" <% if (selected) {%> selected <% } %><% if (!enabled) {%> disabled <% } %>',
                        "data-text=\"<%- quantity %> - <span <% if (salePrice > 0 && price > salePrice) {%>class='strike-price'<% } %>><%- formattedPrice %></span> ",
                        "<% if (salePrice > 0 && price > salePrice) {%><span class='saleprice'>sale price: <%- formattedSalePrice %></span><% } %> \">",

                        '<%- quantity %> - <%- formattedPrice %> sale price: <%- formattedSalePrice %>',
                        '</option>'
                    ].join('')
                );

                var price = pricingCalcSku.getPrice(true);
                var salePrice = pricingCalcSku.getSalePrice(true);

                var selectedOptionValues = pricingCalcItem.getSelectedOptionValues();

                pricingCalcItem.get('options').forEach(function(pricingCalcOption) {
                    var isNonBookletSubstrate =
                        pricingCalcOption.get('option').get('name') === OptionModel.NAME_SUBSTRATE &&
                        !pricingCalcItem.get('product').isBooklet();
                    pricingCalcOption.get('optionValues').forEach(function(pricingCalcOptionValue) {
                        if (pricingCalcOptionValue.get('selected')) {
                            var optionValuePrice = pricingCalcOptionValue.getPrice(
                                pricingCalcSku,
                                selectedOptionValues,
                                undefined,
                                undefined,
                                true
                            );
                            var optionValueSalePrice = pricingCalcOptionValue.getPrice(
                                pricingCalcSku,
                                selectedOptionValues,
                                _this.pricingSetName,
                                isNonBookletSubstrate,
                                true
                            );

                            price += optionValuePrice;
                            salePrice += optionValueSalePrice;
                        }
                    });
                });

                return tmpl({
                    id: pricingCalcSku.get('sku').get('id'),
                    quantity: utils.formatNumber(pricingCalcSku.get('sku').get('quantity')),
                    price: price,
                    salePrice: salePrice,
                    selected: pricingCalcSku.get('selected'),
                    enabled: pricingCalcSku.get('enabled'),
                    formattedPrice: utils.formatPrice(price, this.model.get('currency')),
                    formattedSalePrice: utils.formatPrice(salePrice, this.model.get('currency'))
                });
            },

            /**
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @returns {undefined}
             */
            optionTmpl: function(pricingCalcOption) {
                var tmpl = _.template(this.optionTemplate);

                var option = pricingCalcOption.get('option');
                var image = null;
                var html = '';

                var selectedPricingCalcOptionValue = pricingCalcOption.getSelectedOptionValue();
                var selectedOptionValue = selectedPricingCalcOptionValue.get('optionValue');

                if (selectedPricingCalcOptionValue.get('visible')) {
                    image = this.getImageForOptionValue(selectedOptionValue);

                    html = tmpl({
                        id: pricingCalcOption.cid,
                        name: option.get('name'),
                        title: option.get('title'),
                        description: selectedOptionValue.get('description'),
                        isAlert: selectedOptionValue.get('isAlert'),
                        image: image,
                        valuesHtml: this.getOptionValuesHtml(pricingCalcOption)
                    });
                    this.$options.append(html);
                }
            },

            /**
             * @param {OptionValueModel} optionValue
             * @return {string}
             */
            getImageForOptionValue: function(optionValue) {
                if (OPTION_VALUES_WITH_IMAGE.indexOf(optionValue.get('name')) !== -1) {
                    return SAMPLE_PATH + this.model.get('product').get('slug') + '/' + optionValue.get('name') + '.jpg';
                }

                return '';
            },

            /**
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @returns {string}
             */
            getOptionValuesHtml: function(pricingCalcOption) {
                var optionValuesHtml = '';
                var _this = this;

                pricingCalcOption.get('optionValues').forEach(function(pricingCalcOptionValue) {
                    if (pricingCalcOptionValue.get('visible')) {
                        optionValuesHtml += _this.getOptionValueHtml(
                            pricingCalcOption,
                            pricingCalcOptionValue,
                            _this.getPricingCalcOptionValueIsEnabled(pricingCalcOption, pricingCalcOptionValue)
                        );
                    }
                });

                return this.getOptionHtml(pricingCalcOption.cid, optionValuesHtml);
            },

            /**
             * @param {PricingCalcOption} pricingCalcOption
             * @param {PricingCalcOptionValue} pricingCalcOptionValue
             * @returns {boolean}
             */
            getPricingCalcOptionValueIsEnabled: function(pricingCalcOption, pricingCalcOptionValue) {
                var _this = this;
                var visible = pricingCalcOptionValue.get('visible');
                var enabled = pricingCalcOptionValue.get('enabled');
                var showAsEnabled;

                //if option value of always shown option is disabled, we can still show if it has no conflicts with unchangeable options
                if (_.contains(SHOW_AS_ENABLED_OPTIONS, pricingCalcOption.get('option').get('name')) && visible && !enabled) {
                    showAsEnabled = true;
                    pricingCalcOptionValue
                        .get('optionValue')
                        .get('optionValueConflicts')
                        .forEach(function(conflictName) {
                            _this.model.get('options').forEach(function(pricingCalcOption) {
                                var conflictOptionValue = pricingCalcOption.getOptionValue(conflictName);
                                if (conflictOptionValue && conflictOptionValue.get('selected') && !pricingCalcOption.get('changeable')) {
                                    showAsEnabled = false;
                                }
                            });
                        });
                }

                return enabled || showAsEnabled;
            },

            /**
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @param {PricingCalcOptionValueModel} pricingCalcOptionValue
             * @param {boolean} enabled
             * @returns {string}
             */
            getOptionValueHtml: function(pricingCalcOption, pricingCalcOptionValue, enabled) {
                return this.optionValueTmpl(pricingCalcOptionValue, pricingCalcOption.get('option').get('name'), enabled);
            },

            /**
             * @param {PricingCalcOptionValueModel} pricingCalcOptionValue
             * @param {string} optionName
             * @param {boolean} enabled
             * @returns {function}
             */
            optionValueTmpl: function(pricingCalcOptionValue, optionName, enabled) {
                var tmpl = _.template(this.optionValueTemplate);

                return tmpl(this.getOptionValueTmplAttributes(pricingCalcOptionValue, optionName, enabled));
            },

            /**
             * @param {PricingCalcOptionValueModel} pricingCalcOptionValue
             * @param {string} optionName
             * @param {boolean} enabled
             * @returns {object}
             */
            getOptionValueTmplAttributes: function(pricingCalcOptionValue, optionName, enabled) {
                var optionValue = pricingCalcOptionValue.get('optionValue');
                var name = optionValue.get('name');
                var title = optionValue.get('title');
                var pricing = '';

                if (OPTION_VALUES_PRICING_DISPLAY.indexOf(name) !== -1 && optionValue.get('pricing')) {
                    pricing = '(' + optionValue.get('pricing').toString() + ')';
                }

                if (OPTION_VALUES_ALTERNATIVE_PRICING_DISPLAY.indexOf(name) !== -1 && optionValue.get('pricing')) {
                    var quantity = this.model
                        .getSelectedSku()
                        .get('sku')
                        .get('quantity');
                    var formattedQuantity = utils.formatNumber(quantity);
                    title = formattedQuantity + ' ' + title;
                    pricing = '(' + optionValue.get('pricing').toString({ cardsName: '' }) + ')';
                }

                return {
                    name: name,
                    title: title,
                    description: optionValue.get('isAlert') ? '' : optionValue.get('description'),
                    pricing: pricing,
                    selected: pricingCalcOptionValue.get('selected'),
                    enabled: enabled,
                    colorPreview:
                        optionName === OptionModel.NAME_FILLING
                            ? this.inlineColorPreviewTmpl({ colorClass: this.getColorPreviewClass(name) })
                            : '',
                    tShirtColorPreview:
                        optionName === OptionModel.NAME_T_SHIRT_COLOR
                            ? this.inlineTShirtColorPreviewTmpl({ colorClass: this.getTShirtColorPreviewClass(name) })
                            : ''
                };
            },

            inlineColorPreviewTmpl: _.template(['<span class="insert-color-preview <%- colorClass %>"></span>'].join('')),
            inlineTShirtColorPreviewTmpl: _.template(['<span class="color-preview <%- colorClass %>"></span>'].join('')),

            /**
             * @param {string} string
             * @returns {string}
             */
            getColorPreviewClass: function(string) {
                return string.replace(/_/g, '-');
            },

            /**
             * @param {string} string
             * @returns {string}
             */
            getTShirtColorPreviewClass: function(string) {
                switch (string) {
                    case 'shirt-white':
                        return 'white-t-shirt';
                    case 'shirt-black':
                        return 'black-t-shirt';
                    case 'shirt-navy-blue':
                        return 'navy-blue-t-shirt';
                    case 'shirt-athletic-grey':
                        return 'athletic-grey-t-shirt';
                    case 'shirt-charcoal':
                        return 'charcoal-t-shirt';
                }
            },

            /**
             * @returns {string}
             */
            optionTemplate: [
                '<li data-option-name="<%- name %>">',
                '<div class="product-choice">',
                '<div class="product-choice-label">',
                '<label for="<%= id %>"><%= title %></label>',
                '</div>',
                '<div class="product-choice-control select-simple">',
                '<%= valuesHtml %>',
                '<% if (typeof colorPreview !== "undefined") { %>',
                '<%= colorPreview %>',
                '<% } %>',
                '<% if (typeof tShirtColorPreview !== "undefined") { %>',
                '<%= tShirtColorPreview %>',
                '<% } %>',
                '</div>',
                '<% if (description && isAlert) { %>',
                '<div class="product-option-description alert-description">',
                '<%= description %>',
                '</div>',
                '<% } %>',
                '<% if (image) { %>',
                '<div class="product-option-image">',
                '<img src="<%- image %>" alt="">',
                '</div>',
                '<% } %>',
                '</div>',
                '</li>'
            ].join('\n'),

            optionValueTemplate: [
                '<option value="<%- name %>"<% if (selected) { %> selected<% } %><% if (!enabled) {%> disabled<% } %> data-text="',
                "<span class='option-title'><%- title %></span>",
                "<% if (description) {%> <span class='description'><%- description %></span><% } %>",
                '<% if (pricing) {%> <em><%- pricing %></em><% } %>',
                '<%- colorPreview %>',
                '<%- tShirtColorPreview %>">',
                '">',
                '<%- title %><% if (description) {%> <%- description %><% } %><% if (pricing) {%> <%- pricing %><% } %>',
                '</option>'
            ].join('')
        });
    }
);
